@if(show) {
<app-alert [title]="toastTitle" [message]="toastMessage" [type]="toastType" [duration]="4000" role="alert"
    aria-live="assertive">
</app-alert>
}

<div class="min-h-screen flex items-center justify-center px-4 py-8" style="background-color: hsl(220, 20%, 97%);">
    <!-- Container for stacked cards effect -->
    <div class="relative w-full max-w-[480px]">
        <!-- Back card (furthest) - rotated +3deg -->
        <div class="absolute inset-0 bg-white rounded-2xl opacity-40"
             style="transform: rotate(3deg) translateX(8px) translateY(8px); box-shadow: 0 4px 20px -2px hsla(250, 70%, 55%, 0.1);"></div>

        <!-- Middle card - rotated -2deg -->
        <div class="absolute inset-0 bg-white rounded-2xl opacity-60"
             style="transform: rotate(-2deg) translateX(-4px) translateY(4px); box-shadow: 0 4px 20px -2px hsla(250, 70%, 55%, 0.1);"></div>

        <!-- Main card -->
        <div class="relative bg-white rounded-2xl w-full p-8 sm:p-10"
             style="box-shadow: 0 4px 20px -2px hsla(250, 70%, 55%, 0.1);">

            <!-- Logo -->
            <div class="flex justify-center mb-8">
                <img
                    src="assets/images/ardia.svg"
                    alt="ARDIA"
                    class="h-10 cursor-pointer"
                    routerLink="/"
                    role="button"
                    aria-label="Ir al inicio"
                />
            </div>

            <!-- Icon with check -->
            <div class="flex justify-center mb-6">
                <div class="relative">
                    <div class="w-16 h-16 rounded-full flex items-center justify-center animate-pulse-soft"
                         style="background-color: #3D3DF414;">
                        <svg class="w-8 h-8" style="color: #3D3DF4;" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                        </svg>
                    </div>
                    <!-- Check badge -->
                    <div class="absolute -top-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center animate-bounce-soft"
                         style="background-color: hsl(150, 70%, 45%);">
                        <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                    </div>
                </div>
            </div>

            <!-- Title -->
            <h1 class="text-2xl font-semibold text-gray-900 text-center mb-3">
                ¡Verifica tu correo electrónico!
            </h1>

            <!-- Subtitle -->
            <p class="text-sm text-gray-500 text-center mb-4">
                Hemos enviado un enlace de verificación a:
            </p>

            <!-- Email display -->
            <div class="rounded-xl py-4 px-6 mb-4" style="background-color: #3D3DF40D;">
                <p class="text-lg text-center font-medium" style="color: #3D3DF4;">
                    {{ email }}
                </p>
            </div>

            <!-- Instructions -->
            <p class="text-sm text-gray-500 text-center mb-6 leading-relaxed">
                Por favor, revisa tu bandeja de entrada y haz clic en el enlace para completar tu registro. El enlace expirará en <span class="font-semibold">60 minutos</span>.
            </p>

            <!-- Divider -->
            <div class="border-t border-gray-200 my-6"></div>

            <!-- Resend section -->
            <p class="text-sm text-gray-500 text-center mb-4">
                ¿No recibiste el correo?
            </p>

            <!-- Resend button -->
            <button
                (click)="resendVerificationEmail()"
                [disabled]="isResending"
                class="w-full text-white rounded-xl h-[50px] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center text-sm font-medium transition-all hover:opacity-90"
                style="background: #3D3DF4;"
                aria-label="Reenviar correo de verificación">
                @if(isResending) {
                    Reenviando...
                } @else {
                    Reenviar correo de verificación
                }
            </button>

            <!-- Spam notice -->
            <p class="text-xs text-gray-400 text-center mt-8">
                Revisa también tu carpeta de <span class="font-medium">spam</span> o <span class="font-medium">correo no deseado</span>.
            </p>

            <!-- Action links -->
            <div class="flex gap-4 mt-8 pt-6 border-t border-gray-200">
                <button
                    (click)="goToLogin()"
                    class="flex-1 text-center text-sm font-medium py-2 rounded-lg transition-colors"
                    style="color: #3D3DF4; border: 1px solid #3D3DF433;"
                    aria-label="Ir al inicio de sesión">
                    Ir a inicio de sesión
                </button>
            </div>
        </div>
    </div>
</div>
